<template>
  <span
    v-if="label"
    class="br-status-badge"
    :class="`br-status-badge--${variant}`"
  >
    <img
      v-if="iconUrl"
      :src="iconUrl"
      class="br-status-badge__icon"
      width="12"
      height="12"
      alt=""
    />
    <span class="br-status-badge__text">{{ label }}</span>
  </span>
</template>

<script>
import { BR_LICENSE_ASSETS } from "../../../constants/brLicenseAssets";
import { BR_STATUS, BR_STATUS_LABEL_KEY } from "../utils/brDocument";

const VARIANT_MAP = {
  [BR_STATUS.NOT_YET_EFFECTIVE]: {
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
  },
  [BR_STATUS.APPROVED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeApproved,
  },
  [BR_STATUS.READY]: {
    iconUrl: BR_LICENSE_ASSETS.badgeApproved,
  },
  [BR_STATUS.PENDING]: {
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
    /** 管理端：CDN New_Pending_for_Approval.png；供应商仍用蓝底 ready */
    adminIconUrl: BR_LICENSE_ASSETS.badgePending,
  },
  [BR_STATUS.PENDING_MANUAL]: {
    iconUrl: BR_LICENSE_ASSETS.badgeReady,
    adminIconUrl: BR_LICENSE_ASSETS.badgePending,
  },
  [BR_STATUS.REJECTED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
  [BR_STATUS.CANCELLED]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
  [BR_STATUS.INVALID]: {
    iconUrl: BR_LICENSE_ASSETS.badgeStatusAlert,
  },
};

export default {
  name: "BrStatusBadge",
  props: {
    statusCode: {
      type: String,
      default: "",
    },
    statusName: {
      type: String,
      default: "",
    },
    /** 可選：覆蓋默認文案 key（管理端 P/PA 區分） */
    labelKey: {
      type: String,
      default: "",
    },
    /** supplier | admin；admin 下 P/PA 用黃色徽章 */
    appearance: {
      type: String,
      default: "supplier",
      validator: (value) => ["supplier", "eidt", "approval"].includes(value),
    },
  },
  computed: {
    normalizedCode() {
      return (this.statusCode || "").toUpperCase();
    },
    isAdminPendingTone() {
      return (
        (this.appearance === "eidt" ||this.appearance === "approval" )&&
        (this.normalizedCode === BR_STATUS.PENDING ||
          this.normalizedCode === BR_STATUS.PENDING_MANUAL)
      );
    },
    variant() {
      if (this.normalizedCode === BR_STATUS.NOT_YET_EFFECTIVE) {
        return "not-yet-effective";
      }
      if (this.normalizedCode === BR_STATUS.INVALID) {
        return "invalid";
      }
      if (
        this.normalizedCode === BR_STATUS.READY ||
        this.normalizedCode === BR_STATUS.APPROVED
      ) {
        return "approved";
      }
      if (
        this.normalizedCode === BR_STATUS.PENDING ||
        this.normalizedCode === BR_STATUS.PENDING_MANUAL
      ) {
        return this.isAdminPendingTone ? "pending-admin" : "pending";
      }
      if (this.normalizedCode === BR_STATUS.REJECTED) {
        return "rejected";
      }
      if (
        this.normalizedCode === BR_STATUS.CANCELLED ||
        this.normalizedCode === "C"
      ) {
        return "cancelled";
      }
      return "approved";
    },
    iconUrl() {
      const map = VARIANT_MAP[this.normalizedCode];
      if (!map) {
        return "";
      }
      if (this.isAdminPendingTone && map.adminIconUrl) {
        return map.adminIconUrl;
      }
      return map.iconUrl || "";
    },
    label() {
      const key = this.labelKey || BR_STATUS_LABEL_KEY[this.normalizedCode];
      if (key) {
        const text = this.$t(key);
        return text == null ? "" : String(text).trim();
      }
      return this.statusName || this.statusCode || "";
    },
  },
};
</script>
